import { Component, Input, OnInit } from '@angular/core';
import { IPicture } from '../picture/picture.interface';
import { PictureComponent } from '../picture/picture.component';

@Component({
    selector: 'finder-parallax-image',
    standalone: true,
    template: `<finder-picture [picture]="picture" [lazyLoad]="false"></finder-picture>`,
    imports: [PictureComponent],
    styleUrls: ['./parallax-image.component.scss']
})
export class ParallaxImageComponent implements OnInit {
    @Input() data;

    picture: IPicture;

    ngOnInit(): void {
        this.transformData();
    }

    private transformData() {
        // Make sure we have an image property
        if (!this.data?.image) {
            return;
        }

        // Set the image to parallax
        this.picture = {
            parallax: true,
            parallaxScale: this.data.scale,
            alt: this.data.image.altText,
            title: this.data.image.title
        };

        // Assign the images
        (this.data.image?.srcGroup ?? []).forEach(img => {
            if (img.mediaQuery) {
                this.picture.mobile = img.srcSet;
                this.picture.media = img.mediaQuery;
            } else {
                this.picture.desktop = img.srcSet;
            }
        });
    }
}
